import { render, staticRenderFns } from "./BlockCardEntries.vue?vue&type=template&id=37cc4684"
import script from "./BlockCardEntries.vue?vue&type=script&lang=js"
export * from "./BlockCardEntries.vue?vue&type=script&lang=js"
import style0 from "./BlockCardEntries.vue?vue&type=style&index=0&id=37cc4684&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports